<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@scripts/lib/utils';

const props = withDefaults(
    defineProps<{
        size?: 'xs' | 'sm' | 'md' | 'lg';
        variant?: 'outline' | 'inverted' | 'default';
        class?: HTMLAttributes['class'];
    }>(),
    {
        size: 'sm',
        variant: 'default',
        class: '',
    }
);
</script>

<template>
    <button
        class="focusable inline-flex cursor-pointer items-center rounded-full border-2 font-bold uppercase active:border-black active:bg-black active:text-white leading-none"
        :class="{
            'gap-x-2 px-3 py-1 text-xs sm:gap-x-6 sm:px-4 sm:py-2 sm:text-sm':
                size === 'xs',
            'gap-x-4 px-4 py-2 text-sm sm:gap-x-6 sm:px-6 sm:py-4 sm:text-base':
                size === 'sm',
            'sm:text-md gap-x-6 px-6 py-4 sm:gap-x-10 sm:px-10 sm:py-5':
                size === 'md',
            'text-md sm:text-md gap-x-6 px-6 py-5 sm:gap-x-10 sm:px-10 sm:py-7':
                size === 'lg',
            'border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary':
                variant === 'inverted',
            'border-primary text-primary hover:bg-primary hover:text-primary-foreground':
                variant === 'outline',
            'border-primary bg-primary text-primary-foreground hover:bg-primary-foreground hover:text-primary':
                variant === 'default',
        }"
        v-bind="props"
    >
        <slot />
    </button>
</template>
